<!--
 * @Author: cryi.liu
 * @Date: 2020-07-13 11:34:33
 * @LastEditTime: 2020-07-16 18:11:14
 * @Description: write you description
-->
<template>
  <div class="add-exam-object">
    <div class="add-type">
      <i-radio-group
        :value="addExamObjectType"
        size="small" @on-change="addExamObjectTypeChangeHandler">
        <i-radio label="Scope" :disabled="!canAddExamObject">根据Scope设置</i-radio >
        <i-radio label="Excel" :disabled="!canAddExamObject">上传Excel设置</i-radio >
      </i-radio-group>
    </div>
    <div class="add-exam-object-wrapper">
      <component
        :is="currentCom"
        :exam-id="examId" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import AddExamObjectByScope from './AddExamObjectByScope.vue';
import AddExamObjectByExcel from './AddExamObjectByExcel.vue';

export default {
  name: 'AddExamObject',
  props: {
    examId: { type: [Number, String], required: false },
  },
  data() {
    return {
      currentCom: null,
    };
  },
  computed: {
    ...mapGetters({
      addExamObjectType: 'createPaperStore/addExamObjectType',
      canAddExamObject: 'createPaperStore/canAddExamObject',
    }),
  },
  watch: {
    addExamObjectType: {
      immediate: true,
      handler(addType) {
        if (addType === 'Scope') {
          this.currentCom = AddExamObjectByScope;
        } else if (addType === 'Excel') {
          this.currentCom = AddExamObjectByExcel;
        }
      },
    },
  },
  methods: {
    ...mapActions({
      setAddExamObjectType: 'createPaperStore/invokeSetAddExamObjectType',
    }),
    /**
     * 添加考试对象方式更改处理函数
     */
    addExamObjectTypeChangeHandler(value) {
      this.setAddExamObjectType({ addExamObjectType: value });
    },
  },
};
</script>

<style lang="less" scoped>
.add-exam-object {
  margin-bottom: 16px;
  width: 100%;
  padding-top: 16px;
  border-top: 1px solid #ddd;

  & > .add-type {
    margin-bottom: 20px;
  }
}
</style>
